class Header {
  linkPopup;
  desktopPopup;
  headerWrapper;
  logoImage;
  htmlElement;
  header;

  init() {
    this.linkPopup = document.querySelector('.mobile-overlay__text-popup');
    this.desktopPopup = document.querySelector('.mobile-overlay__desktop-popup');
    this.headerWrapper = document.querySelector('.header__wrapper');
    this.logoImage = document.getElementById('logoImage');
    this.htmlElement = document.querySelector('html');
    this.header = document.querySelector('.header');

    if (this.linkPopup) {
      this.linkPopup.addEventListener('click', () => this.togglePopup());
      this.linkPopup.addEventListener('mouseenter', () => this.handleMouseEnter());
      this.linkPopup.addEventListener('mouseleave', () => this.handleMouseLeave());
    }

    if (this.desktopPopup) {
      this.desktopPopup.addEventListener('mouseenter', () => this.handleMouseEnter());
      this.desktopPopup.addEventListener('mouseleave', () => this.handleMouseLeave());
    }

    if (this.headerWrapper) {
      this.headerWrapper.addEventListener('mouseleave', () => this.handleMouseLeave());
    }

    if (this.header) {
      if (this.header.classList.contains('theme-dark')) {
        this.setDarkLogo();
      } else {
        this.setLightLogo();
      }
    }

    this.checkNavigationClass();
    const observer = new MutationObserver(() => this.checkNavigationClass());
    observer.observe(this.htmlElement, { attributes: true, attributeFilter: ['class'] });
  }

  checkNavigationClass() {
    if (this.htmlElement.classList.contains('mobile-show-navigation')) {
      this.setLightLogo();
    } else {
      if (this.header.classList.contains('theme-dark')) {
        this.setDarkLogo();
      } else {
        this.setLightLogo();
      }
    }
  }

  togglePopup() {
    this.linkPopup.classList.toggle('mobile-overlay__text-popup--active');
  }

  handleMouseEnter() {
    this.linkPopup.classList.add('mobile-overlay__text-popup--active');
  }

  handleMouseLeave() {
    const linkPopupHover = this.linkPopup.matches(':hover');
    const desktopPopupHover = this.desktopPopup.matches(':hover');
    const headerWrapperHover = this.headerWrapper.matches(':hover');

    if (!linkPopupHover && !desktopPopupHover && !headerWrapperHover) {
      this.linkPopup.classList.remove('mobile-overlay__text-popup--active');
    }
  }

  setDarkLogo() {
    var hiddenInput = document.getElementById('hiddenLogoDark');
    this.logoImage.src = hiddenInput.value;
  }

  setLightLogo() {
    var hiddenInput = document.getElementById('hiddenLogoWhite');
    this.logoImage.src = hiddenInput.value;
  }
}

export const header = new Header();
